// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CzIB","delete":"styles_delete__-GaMm","update":"styles_update__2CX4x","add":"styles_add__12cSF"};